/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const SetupOAuthResultParser = /* #__PURE__ */ parsers.object([
    ['returnUrl', codecString, 'return_url'],
]);
export class SetupOAuthResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return SetupOAuthResultParser.decode(input).map(res => new SetupOAuthResult(res));
    }
    static unsafeDecode(input) {
        return SetupOAuthResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return SetupOAuthResultParser.encode(data);
    }
    static schema() {
        return SetupOAuthResultParser.schema();
    }
}
